export default __webpack_public_path__ + "static/media/kids-waiting-room-mobile.1d8a2c56.png";